import Service from "../../Services";

const Branch = {
  namespaced: true,
  state: {
    form: {
      branch_id: "",
      branch_name_th: "",
      branch_name_en: "",
      tag_name: "",
      orders: "",
      img_cover_mobile_path: "",
      img_cover_mobile_name: "",
      img_cover_desktop_name: "",
      img_cover_desktop_path: "",
      service_area_image: "",
      mobile_path_show: "",
      desktop_path_show: "",
      service_area_image_show: "",
      active: null
    }
  },
  mutations: {
    GET_FORM_BRANCH: (state, res) => {
      state.form = res;
    },
    CLEAR_FORM_DATA: state => {
      state.form = {
        branch_id: "",
        branch_name_th: "",
        branch_name_en: "",
        tag_name: "",
        orders: "",
        img_cover_mobile_path: "",
        img_cover_mobile_name: "",
        img_cover_desktop_name: "",
        img_cover_desktop_path: "",
        service_area_image: "",
        mobile_path_show: "",
        desktop_path_show: "",
        service_area_image_show: "",
        active: null
      };
    }
  },
  actions: {
    getBranch({ commit }, { page, search, sort }) {
      return Service.BranchAPI.getBranch(page, search, sort);
    },
    showBranch({ commit }, id) {
      return Service.BranchAPI.showBranch(id);
    },
    saveBranch({ commit }, { id, data }) {
      if (id) {
        //update
        return Service.BranchAPI.updateBranch(id, data);
      } else {
        //create
        return Service.BranchAPI.createBranch(data);
      }
    },
    deleteBranch({ commit }, id) {
      return Service.BranchAPI.deleteBranch(id);
    },
    setFormBranch({ commit }, res) {
      commit("GET_FORM_BRANCH", res);
    },
    clearFormData({ commit }) {
      commit("CLEAR_FORM_DATA");
    },
    getBranchAll() {
      return Service.BranchAPI.getBranchAll();
    },
    // เรียงเลข order ใหม่ให้ต่อเนื่องตามลำดับเดิม: ALL BRANCHES (branch_id 0) = 0, สาขาอื่น = 1..n
    // บันทึกเฉพาะสาขาที่เลขเปลี่ยน ส่งกลับเป็น array ชื่อสาขาที่บันทึกไม่สำเร็จ (array ว่าง = สำเร็จทั้งหมด)
    async renumberBranchOrders() {
      const branches = await Service.BranchAPI.getBranchAll();
      const sorted = [...(branches || [])].sort((a, b) =>
        (Number(a.orders) || 0) - (Number(b.orders) || 0) || a.branch_id - b.branch_id
      );
      const changes = [];
      let next = 1;
      sorted.forEach(item => {
        const newOrder = item.branch_id === 0 ? 0 : next++;
        if (Number(item.orders) !== newOrder) {
          changes.push({ ...item, orders: newOrder });
        }
      });
      // ส่งบันทึกทุกสาขาพร้อมกัน แล้วเก็บชื่อสาขาที่ API ตอบไม่สำเร็จหรือ error
      const results = await Promise.all(changes.map(item =>
        Service.BranchAPI.updateBranch(item.branch_id, item)
          .then(res => (!res || res.response_code != 200 ? item.branch_name_th : null))
          .catch(() => item.branch_name_th)
      ));
      return results.filter(name => name !== null);
    }
  }
};
export default Branch;
